/**
 * Sortuje jachty wg displayOrder (rosnąco), a brakujące wartości na końcu.
 * Dla remisu fallback po nazwie (locale: pl).
 */
export function sortYachtsForDisplay(yachts) {
  return [...yachts].sort((a, b) => {
    const ao =
      typeof a.displayOrder === 'number' && !Number.isNaN(a.displayOrder)
        ? a.displayOrder
        : Number.MAX_SAFE_INTEGER;
    const bo =
      typeof b.displayOrder === 'number' && !Number.isNaN(b.displayOrder)
        ? b.displayOrder
        : Number.MAX_SAFE_INTEGER;

    if (ao !== bo) return ao - bo;
    return (a.name || '').localeCompare(b.name || '', 'pl');
  });
}
